/**
 * 退会（アカウント削除）完了メッセージ。design §5.6
 * Cognito Hosted UI の logout_uri は登録済み URL と厳密一致が必要でクエリを付与できないため、
 * signOut({ reason: "account_deleted" }) 側で sessionStorage にフラグを立て、
 * リダイレクト後のマウント時に一度だけ表示する（「?deleted=1」相当）。
 */
import React, { useEffect, useState } from "react";
import { POST_SIGNOUT_MESSAGE_KEY } from "../../../contexts/AuthContext";

export const PostDeletionNotice: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(POST_SIGNOUT_MESSAGE_KEY) === "account_deleted") {
        setShow(true);
        sessionStorage.removeItem(POST_SIGNOUT_MESSAGE_KEY);
      }
    } catch {
      // ignore
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 pt-[env(safe-area-inset-top)] flex justify-center px-4 pointer-events-none">
      <div className="mt-3 max-w-md w-full bg-slate-900 dark:bg-slate-700 text-white text-sm rounded-xl shadow-lg px-4 py-3 flex items-center justify-between gap-3 pointer-events-auto">
        <span>退会が完了しました。ご利用ありがとうございました。</span>
        <button
          onClick={() => setShow(false)}
          className="text-slate-300 hover:text-white flex-shrink-0 cursor-pointer"
          aria-label="閉じる"
        >
          ×
        </button>
      </div>
    </div>
  );
};
